(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('header');
    var toggle = header.querySelector('.header__search-toggle');
    var searchBar = header.querySelector('.header__search');
    var input = searchBar.querySelector('.header__search-input');
    var close = searchBar.querySelector('.header__search-close');

    if (toggle) {
      toggle.addEventListener('click', function() {
        searchBar.hidden = false;
        input.focus();
      });
    }

    close.addEventListener('click', function() {
      searchBar.hidden = true;
      input.value = '';
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !searchBar.hidden) {
        searchBar.hidden = true;
        input.value = '';
      }
    });

    /* Checkout pill button */
    var checkoutBtn = header.querySelector('[data-header-checkout]');
    if (checkoutBtn) {
      var label = checkoutBtn.querySelector('[data-checkout-label]');
      var msg = checkoutBtn.querySelector('[data-checkout-msg]');
      var msgTimer = null;

      checkoutBtn.addEventListener('click', function() {
        var countEl = header.querySelector('[data-cart-count]');
        var hasItems = countEl && !countEl.hidden;

        if (hasItems) {
          window.location.href = '/checkout';
        } else {
          checkoutBtn.classList.add('header__checkout--msg');
          label.hidden = true;
          msg.hidden = false;

          clearTimeout(msgTimer);
          msgTimer = setTimeout(function() {
            checkoutBtn.classList.remove('header__checkout--msg');
            label.hidden = false;
            msg.hidden = true;
          }, 3000);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
